import { Navigate } from "react-router-dom";
import { APP_ROUTES } from "./AppRoutes";
import Seo from "../seo/Seo";
import { seoContent } from "../seo/seoContent";
import HomePage from "../pages/HomePage";
import AboutUsPage from "../pages/AboutUsPage";
import ContactUsPage from "../pages/ContactUsPage";
import HkiAnimatica from "../pages/HkiAnimatica";
import EntertainmentPage from "../pages/EntertainmentPage";
import CoursePage from "../pages/CoursePage";
import ServicesPage from "../pages/ServicesPage";
import MediaServicesPage from "../pages/MediaServicesPage";
import ServiceDetailPage from "../pages/ServiceDetailPage";
import MediaAppPage from "../pages/MediaAppPage";
import EventPlanPage from "../pages/EventPlanPage";
import VrArPage from "../pages/VrArPage";
import CmYuvaScheme from "../pages/CmYuvaSchemePage";
import Corporate from "../pages/CorporatePage";
import FranchisePage from "../pages/FranchisePage";
import OurWorkPage from "../pages/OurWorkPage";
import EventsExperiencesPage from "../pages/EventsExperiencesPage";
import InfluencerMarketingPage from "../pages/InfluencerMarketingPage";
import CelebrityMarketingPage from "../pages/CelebrityMarketingPage";
import AiContentCreationPage from "../pages/AiContentCreationPage";
import News from "../pages/News";
import Blogs from "../pages/Blogs";
import BlogPostPage from "../pages/BlogPostPage";
import MovieLinksPage from "../pages/MovieLinksPage";
import Privacypolicy from "../pages/Privacypolicy";
import NotFoundPage from "../pages/NotFoundPage";

// Renders the page's <head> SEO tags alongside the page.
const withSeo = (page, seo) => (
  <>
    <Seo {...seo} />
    {page}
  </>
);

export const routes = [
  { path: APP_ROUTES.HOME, element: withSeo(<HomePage />, seoContent.home) },
  { path: APP_ROUTES.ABOUT_US, element: <AboutUsPage /> },
  { path: APP_ROUTES.CONTACT_US, element: withSeo(<ContactUsPage />, seoContent.contact) },
  { path: APP_ROUTES.HKI_ANIMATICA, element: withSeo(<HkiAnimatica />, seoContent.skilling) },
  { path: APP_ROUTES.ENTERTAINMENT, element: withSeo(<EntertainmentPage />, seoContent.entertainment) },
  { path: APP_ROUTES.COURSES, element: <CoursePage /> },
  { path: APP_ROUTES.SERVICES, element: <ServicesPage /> },
  { path: APP_ROUTES.MEDIA_SERVICES.GET_MEDIA_SERVICES, element: <MediaServicesPage /> },
  { path: APP_ROUTES.MEDIA_SERVICES.VIEW_SERVICE(), element: <ServiceDetailPage /> },
  { path: APP_ROUTES.MEDIA_MATRIX_APP, element: <MediaAppPage /> },
  { path: APP_ROUTES.EVENT_PLAN, element: <EventPlanPage /> },
  { path: APP_ROUTES.AR_VR, element: withSeo(<VrArPage />, seoContent.arVr) },
  // Old URL, kept so existing links and search results still land on the page.
  // (/About-Us and /Franchise need no redirect: route matching ignores letter case.)
  { path: "/arvr", element: <Navigate to={APP_ROUTES.AR_VR} replace /> },
  { path: APP_ROUTES.GIGMATIC_STUDIOS, element: withSeo(<CmYuvaScheme />, seoContent.cmYuva) },
  { path: APP_ROUTES.CORPORATE, element: withSeo(<Corporate />, seoContent.corporate) },
  { path: APP_ROUTES.FRANCHISE, element: withSeo(<FranchisePage />, seoContent.franchise) },
  { path: APP_ROUTES.OUR_WORK, element: <OurWorkPage /> },
  { path: APP_ROUTES.EVENTS_EXPERIENCES, element: withSeo(<EventsExperiencesPage />, seoContent.eventsExperiences) },
  { path: APP_ROUTES.INFLUENCER_MARKETING, element: withSeo(<InfluencerMarketingPage />, seoContent.influencerMarketing) },
  { path: APP_ROUTES.CELEBRITY_MARKETING, element: withSeo(<CelebrityMarketingPage />, seoContent.celebrityMarketing) },
  { path: APP_ROUTES.AI_CONTENT_CREATION, element: withSeo(<AiContentCreationPage />, seoContent.aiContentCreation) },
  { path: APP_ROUTES.NEWS, element: withSeo(<News />, seoContent.news) },
  { path: APP_ROUTES.BLOGS.GET_BLOGS, element: withSeo(<Blogs />, seoContent.blogs) },
  { path: APP_ROUTES.BLOGS.VIEW_BLOG_POST(), element: <BlogPostPage /> },
  { path: APP_ROUTES.MOVIE_LINKS.GET_MOVIE_LINKS, element: <MovieLinksPage /> },
  { path: APP_ROUTES.MOVIE_LINKS.VIEW_MOVIE_LINKS_WITH_REFERRAL(), element: <MovieLinksPage /> },
  { path: APP_ROUTES.PRIVACY_POLICY, element: <Privacypolicy /> },
  { path: APP_ROUTES.CATCH_ALL, element: <NotFoundPage /> },
];
